var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgAccordionLeft = function SvgAccordionLeft(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    "aria-label": "Accordion Left",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u21B3-Icons-\\uD83D\\uDD04",
    stroke: "none",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("g", {
    id: "AZ_DLS_Icons",
    transform: "translate(-753.000000, -230.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Chevron-left",
    transform: "translate(753.000000, 230.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6,4 L6,12 C6,12.4454524 6.53857096,12.6685358 6.85355339,12.3535534 L10.8535534,8.35355339 C11.0488155,8.15829124 11.0488155,7.84170876 10.8535534,7.64644661 L6.85355339,3.64644661 C6.53857096,3.33146418 6,3.55454757 6,4 Z",
    id: "Icons/16/Accordion---left"
  }))))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgAccordionLeft);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "accordion-left.09ed817f277be04e53308498967991f4.svg";